<template>
  <component :is="currentPanelComponent" v-bind="currentPanelProps" />
</template>

<script>
import DateTimePickerPanel from './Panels/DateTimePickerPanel.vue'
import DatePickerPanel from './Panels/DatePickerPanel.vue'
import PanelControl from './Components/PanelControl.vue'
import PeopleSelector from './Panels/PeopleSelector.vue'
import TimePickerPanel from './Panels/TimePickerPanel.vue'
import OptionPickerPanel from './Panels/OptionPickerPanel.vue'
import { useBottomPanelStore } from 'Store/bottom-panel'
import { useDatepickerStore } from 'Store/datepicker'

export default {
  components: {
    DateTimePickerPanel,
    DatePickerPanel,
    PanelControl,
    PeopleSelector,
    TimePickerPanel,
    OptionPickerPanel
  },

  setup() {
    return {
      bottomPanelStore: useBottomPanelStore(),
      datepickerStore: useDatepickerStore()
    }
  },

  computed: {
    currentPanelComponent() {
      return this.bottomPanelStore.component
    },
    disabledDates() {
      return this.datepickerStore.disabledDates
    },
    enabledDates() {
      return this.datepickerStore.enabledDates
    },
    currentPanelProps() {
      switch (this.currentPanelComponent) {
        case 'DatePickerPanel':
          return {
            disabledDates: this.disabledDates,
            enabledDates: this.enabledDates
          }
        case 'DateTimePickerPanel':
          return {
            disabledDates: this.disabledDates,
            enabledDates: this.enabledDates
          }
        default:
          return {}
      }
    }
  }
}
</script>
